<div 
  #indicationsListRef [attr.data-from-planner]="true" 
  class="indications-list-container" 
  [class.mobile]="fromPointPlannerCustomRouteMobile()"
  [class.margin-bottom-desktop]="fromPointPlannerCustomRouteDesktop()" 
  [class.margin-bottom-mobile]="fromPointPlannerCustomRouteMobile()"
>
  @for(transfer of transfers(); track $index; let last = $last) {
    <div #itemElements>
      <indication  [class.opacity]="currentStepIndex() > $index" [class.current]="currentStepIndex() === $index"
          [intructions]="transfer.instruction" 
          [timeRemaining]="getTimeRemaining(transfer.duration)"
          [progress]="getProgress($index + 1)"
          [sign]="getSign($index)"
          [isSuccess]="getProgress($index + 1) === 100"
      ></indication>
    </div>

    @if (!last){
      <hr>
    }

  }
</div>

<ci-icon-button
  [class.bottom-sheet-mobile__close-button]="fromPointPlannerCustomRouteMobile()"
  [class.bottom-sheet-desktop__close-button]="fromPointPlannerCustomRouteDesktop()"
  (click)="closeBottomSheet()"
  type="tonal" 
  name="close"
></ci-icon-button>

<app-drag-handle />
